import dayjs from 'dayjs';
import { IKpiPreset } from 'app/shared/model/kpi-preset.model';
import { IKpiEvent } from 'app/shared/model/kpi-event.model';

export interface IKpiConf {
  id?: number;
  value?: number | null;
  valueMin?: number | null;
  valueMax?: number | null;
  kpiPreset?: IKpiPreset | null;
  kpiEvent?: IKpiEvent | null;
}

export const defaultValue: Readonly<IKpiConf> = {};
